import { createApp, h } from 'vue';
import { createRouter, createWebHashHistory } from 'vue-router';
import KioskView from './views/KioskView.vue';
import App from './App.vue';

// Inline render function (not a template string) because Vite's prod build
// of Vue excludes the runtime template compiler.
const HomeView = {
  render() {
    return h(
      'div',
      { style: 'padding:2rem;font-family:system-ui' },
      [
        h('h2', 'Lymon Embed'),
        h('p', 'Designs render in the kiosk shell or the app\'s tokenized /screen routes.'),
      ],
    );
  },
};

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    // Doc 34 — kiosk/screen shell. Authenticates with a device token (enrolled
    // once via ?enroll=<code>) and rotates the assigned designs.
    {
      path: '/kiosk',
      component: KioskView,
    },
    {
      path: '/',
      component: HomeView,
    },
  ],
});

createApp(App).use(router).mount('#app');
